import { CarouselItem } from "@atoms/carousel-item";
import { Section } from "@atoms/section";
import { Typography } from "@atoms/typography";
import { FAQItem, FAQItemProps } from "@molecules/faq-item";
import { LayoutTemplate } from "@templates/layout";
import React, { FC } from "react";
import styled from "styled-components";

export type FAQTemplateProps = {
  faqs: FAQItemProps[];
};

export const FAQTemplate: FC<FAQTemplateProps> = ({ faqs }) => {
  return (
    <LayoutTemplate page="faq">
      <CarouselItem
        imageStandard="/images/header_faq.jpg"
        imageWebp="/images/header_faq.webp"
      />
      <Section>
        <Typography variant="title1">FAQ</Typography>
        <Grid>
          {faqs.map((c, i) => (
            <FAQItem key={`faq_${i}`} title={c.title} content={c.content} />
          ))}
        </Grid>
      </Section>
    </LayoutTemplate>
  );
};

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1em 2em;

  @media (min-width: 48em) {
    grid-template-columns: 1fr 1fr;
  }
`;
